import palette from '@lib/core/src/theme/palette';
import { Stack, styled, Typography } from '@mui/material';

export const ComingSoon = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '16px',
  color: palette.grey[500]
});

export const Title = styled(Typography)({
  fontSize: '28px',
  lineHeight: '36px',
  fontWeight: 600,
  fontStyle: 'normal',
  color: palette.black
});

export const Wrapper = styled(Stack)({
  display: 'flex',
  gap: '6px'
});
